import React from 'react';
import i18n from '../../i18n/i18n.js';
import { ReactSVG } from "react-svg";
import PageHeader from "../../components/PageHeader/PageHeader.js";
import Form from '../../components/Forms/Form/Form';
import {Utils,NavigateTo} from './../../Utils';
import { withAppContext, ModalsContext } from '../../contexts/AppContext';
import './Profile.css'; 
import { redirect } from 'react-router-dom';

class Profile extends React.Component {
  
  static contextType = ModalsContext;

  constructor(props) {
    super(props);
    
    this.state = {
      show: false,
      hiding: false,
      redirect: false,
    };

    this.appRef = this.props.appContext.appRef;
  }

  /**
   * Form hívja meg ha sikeresen lefutott a handle_submit()
   * ha nincs szükség erre a fv.-re akkor lehet törölni
   */
  on_submit_success(params = {formData: {}, result: {}}) {
    this.hide();
  }

  show() {
    this.setState({show: true});
  }

  hide() {
    this.setState({hiding: true}, function() {
      setTimeout(() => {
        this.setState({show: false, hiding: false});
      }, 200);
    });
  }

  toggle() {
    if (this.state.show)
    {
      this.hide();
    }
    else {
      this.show();
    }
  }

  /**
   * alárendelt komponensek megnyitása (Számlázási cím, Szállítási cím, Fizetési mód)
   */
  handle_link_click(e, target) {
    if (typeof this.context[target + 'Ref'].current !== 'undefined')
    {
      this.context[target + 'Ref'].current.toggle();
    }
  }

  handle_delete_reg_click(e) {
    e.preventDefault();

    this.appRef.current.set_dialog_message(i18n.t('profileDeleteRegistrationConfirm'), {
      cancel: true,
      callback: () => 
      {
        Utils.get_server_data(
          '', 
          {ajax_event: 'delete_registration', APICACHE: 'false'}, 
          {ajax_event: 'delete_registration', formData: JSON.stringify({})}
        )
          .then((res) => {
            if (res.success == 1)
            {
              this.setState({redirect:true},()=>{

                this.setState({redirect:false});

                this.context.ProfileRef.current.hide();

                if(this.context.AppHeaderRef?.current){
                  this.context.AppHeaderRef.current.setState({signed:0});
                }

                if(this.context.ProfileMenuRef?.current){
                  this.context.ProfileMenuRef.current.setState({is_signed:0});
                }

              });
            }
            else {
              this.appRef.current.set_dialog_message(i18n.t('profileDeleteRegistrationFail'));
            }
          });        
      }
    });
  }

  handle_logout_click() {
    this.appRef.current.logout();
  }

  render() {
    const { show, hiding } = this.state;

    if (this.state.redirect===true){return <NavigateTo toURL='/'></NavigateTo>}

    if (!show) return '';

    return <div className={`container floating_container page_checkout page_profile ${hiding ? 'out' : ''}`}>
          <div className="content">
            
            <PageHeader parent_ref={this} no_close title={i18n.t('profileTitle')} />

            <div className='container_inner'>

              <Form name="profile" submit_text={i18n.t('save')} parent={this} />

              <div className='links'>
                <div className='link' onClick={(e) => this.handle_link_click(e, 'ProfilePersonalDatas')}>{i18n.t('ProfilePersonalDatas')}<ReactSVG src="/assets/images/chevron.svg" /></div>
                <div className='link' onClick={(e) => this.handle_link_click(e, 'ProfileBillAddress')}>{i18n.t('profileBillAddress')}<ReactSVG src="/assets/images/chevron.svg" /></div>
                <div className='link' onClick={(e) => this.handle_link_click(e, 'ProfileDeliveryAddresses')}>{i18n.t('profileDeliveryAddress')}<ReactSVG src="/assets/images/chevron.svg"/></div>
               
                <div className='link red' onClick={(e) => this.handle_delete_reg_click(e)}>{i18n.t('profileDeleteRegistration')}</div>
                {/*<div className='link' onClick={(e) => this.handle_link_click(e, 'ProfilePaymentMethod')}>{i18n.t('profilePaymentMethod')}<ReactSVG src="assets/images/arrow_down.svg" /></div>*/}
                <div className='link' onClick={() => this.handle_logout_click()}>{i18n.t('profileLogout')}</div>
              </div> 
            
            </div>
          </div>
      </div>;
  }
}

export default withAppContext(Profile);